import React, { useEffect, useRef, useState } from 'react';
import { api } from '../api/client';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const METHOD_LABELS: Record<string, string> = {
  qpay: 'QPay', bpay: 'BPay', bank_transfer: 'Банк шилжүүлэг', cash: 'Бэлэн мөнгө', socialpay: 'SocialPay', card: 'Карт',
};
const STATUS_LABELS: Record<string, string> = {
  paid: 'Төлсөн', pending: 'Хүлээгдэж буй', failed: 'Амжилтгүй', refunded: 'Буцаасан', cancelled: 'Цуцалсан',
};
const STATUS_COLORS: Record<string, string> = {
  paid: '#10b981', pending: '#f59e0b', failed: '#ef4444', refunded: '#6b7280', cancelled: '#6b7280',
};

export default function PaymentsPage() {
  const [payments, setPayments] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showManual, setShowManual] = useState(false);

  // Гараар бүртгэх: Байр → Тоот → Нэхэмжлэх шаталсан сонголт
  const [units, setUnits] = useState<any[]>([]);
  const [mBuilding, setMBuilding] = useState('');
  const [mUnitId, setMUnitId] = useState('');
  const [mInvoices, setMInvoices] = useState<any[]>([]);
  const [mInvoiceId, setMInvoiceId] = useState('');
  const [mAmount, setMAmount] = useState('');
  const [mMethod, setMMethod] = useState('cash');
  const [mReference, setMReference] = useState('');
  const [mSaving, setMSaving] = useState(false);
  const [mMsg, setMMsg] = useState('');

  // Банкны хуулга импорт
  const importRef = useRef<HTMLInputElement>(null);
  const [importing, setImporting] = useState(false);
  const [importResult, setImportResult] = useState<any>(null);
  const [importError, setImportError] = useState('');

  const loadPayments = () => {
    api.get('/admin/payments').then(res => setPayments(Array.isArray(res) ? res : res?.items || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(loadPayments, []);
  useEffect(() => {
    api.get('/admin/units?limit=1000').then(res => setUnits(res?.items || [])).catch(() => {});
  }, []);

  const numSort = (a: any, b: any) => String(a).localeCompare(String(b), 'mn', { numeric: true });
  const mBuildings = Array.from(new Set(units.map((u: any) => u.building).filter(Boolean))).sort(numSort);
  const mUnits = units
    .filter((u: any) => u.building === mBuilding)
    .sort((a: any, b: any) => numSort(a.unit_number, b.unit_number));

  // Тоот сонгоход тухайн айлын ТӨЛӨГДӨӨГҮЙ нэхэмжлэхүүдийг татна
  useEffect(() => {
    setMInvoices([]); setMInvoiceId(''); setMAmount('');
    if (!mUnitId) return;
    api.get(`/admin/invoices?unit_id=${mUnitId}&limit=50`).then(res => {
      const unpaid = (res?.items || []).filter((i: any) => (i.total_amount - i.paid_amount) > 0 && i.status !== 'draft');
      setMInvoices(unpaid);
      if (unpaid.length === 1) {
        setMInvoiceId(unpaid[0].id);
        setMAmount(String(unpaid[0].total_amount - unpaid[0].paid_amount));
      }
    }).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mUnitId]);

  const onInvoicePick = (id: string) => {
    setMInvoiceId(id);
    const inv = mInvoices.find((i: any) => i.id === id);
    if (inv) setMAmount(String(inv.total_amount - inv.paid_amount));
  };

  const handleManualPayment = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!mInvoiceId) { setMMsg('Алдаа: нэхэмжлэх сонгоно уу'); return; }
    setMSaving(true); setMMsg('');
    try {
      await api.post('/admin/payments/record', {
        invoice_id: mInvoiceId,
        amount: parseInt(mAmount) || 0,
        method: mMethod,
        reference: mReference,
      });
      setMMsg('Төлбөр бүртгэгдлээ — нэхэмжлэхээс хасагдсан');
      setMUnitId(''); setMInvoiceId(''); setMAmount(''); setMReference('');
      loadPayments();
      setTimeout(() => setMMsg(''), 4000);
    } catch (err: any) {
      setMMsg(`Алдаа: ${err?.body ? JSON.parse(err.body)?.detail || 'бүртгэж чадсангүй' : 'бүртгэж чадсангүй'}`);
    } finally { setMSaving(false); }
  };

  const handleImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImporting(true); setImportResult(null); setImportError('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await fetch(`${API}/admin/reconciliation/import-file`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` },
        body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Сервер алдаа (HTTP ${res.status})`);
      setImportResult(data);
      loadPayments();
    } catch (err: any) {
      setImportError(err.message || 'Алдаа гарлаа');
    } finally {
      setImporting(false);
      if (importRef.current) importRef.current.value = '';
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 8 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22', margin: 0 }}>Төлбөр</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <input ref={importRef} type="file" accept=".xlsx,.xls" onChange={handleImport} style={{ display: 'none' }} />
          <button onClick={() => importRef.current?.click()} disabled={importing} style={{
            background: '#eff6ff', color: '#2563eb', border: 'none', padding: '8px 20px',
            borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, opacity: importing ? 0.6 : 1,
          }}>{importing ? 'Уншиж байна...' : '⇪ Банкны хуулга оруулах (Excel)'}</button>
          <button onClick={() => setShowManual(!showManual)} style={btnPrimary}>
            {showManual ? 'Болих' : '+ Гар аргаар бүртгэх'}
          </button>
        </div>
      </div>

      {importError && (
        <div style={{ background: '#fee2e2', color: '#dc2626', padding: '10px 14px', borderRadius: 10, marginBottom: 16, fontSize: 14 }}>
          {importError}
        </div>
      )}
      {importResult && (
        <div style={{ background: '#f0fdf4', color: '#166534', padding: '12px 14px', borderRadius: 10, marginBottom: 16, fontSize: 14 }}>
          Хуулга уншигдлаа: {importResult.total} орлогын гүйлгээ — <strong>{importResult.matched} автоматаар тулгагдаж хасалт хийгдлээ</strong>
          {importResult.unmatched > 0 && <>, {importResult.unmatched} тулгагдаагүй → <a href="/reconciliation" style={{ color: '#166534', fontWeight: 700 }}>Тулгалт хуудсаас</a> гараар холбоно уу</>}
          {importResult.skipped_rows > 0 && <span style={{ color: '#5f6f66' }}> (алгассан мөр: {importResult.skipped_rows})</span>}
        </div>
      )}

      {showManual && (
        <div style={card}>
          <h3 style={{ marginBottom: 4, fontSize: 16 }}>Төлбөр гар аргаар бүртгэх</h3>
          <p style={{ margin: '0 0 16px', fontSize: 13, color: '#5f6f66' }}>
            Банкны касс дээр бэлнээр/шилжүүлгээр төлсөн төлбөрийг айлын нэхэмжлэхээс хасна.
          </p>
          {mMsg && (
            <div style={{
              background: mMsg.includes('Алдаа') ? '#fee2e2' : '#f0fdf4',
              color: mMsg.includes('Алдаа') ? '#dc2626' : '#166534',
              padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: 13.5,
            }}>{mMsg}</div>
          )}
          <form onSubmit={handleManualPayment} style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
            <div>
              <label style={labelStyle}>Байр *</label>
              <select value={mBuilding} onChange={e => { setMBuilding(e.target.value); setMUnitId(''); }} style={inputStyle} required>
                <option value="">-- Байр --</option>
                {mBuildings.map((b: any) => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Тоот *</label>
              <select value={mUnitId} onChange={e => setMUnitId(e.target.value)} style={inputStyle} disabled={!mBuilding} required>
                <option value="">{mBuilding ? '-- Тоот --' : 'Эхлээд байраа сонгоно уу'}</option>
                {mUnits.map((u: any) => <option key={u.id} value={u.id}>{u.unit_number}{u.entrance ? ` (${u.entrance}-р орц)` : ''}</option>)}
              </select>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Нэхэмжлэх *</label>
              <select value={mInvoiceId} onChange={e => onInvoicePick(e.target.value)} style={inputStyle} disabled={!mUnitId} required>
                <option value="">
                  {!mUnitId ? 'Эхлээд тоотоо сонгоно уу' : mInvoices.length === 0 ? 'Төлөгдөөгүй нэхэмжлэх алга' : '-- Нэхэмжлэх сонгох --'}
                </option>
                {mInvoices.map((i: any) => (
                  <option key={i.id} value={i.id}>
                    {i.period} — үлдэгдэл ₮{(i.total_amount - i.paid_amount).toLocaleString()}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Дүн (₮) *</label>
              <input type="number" value={mAmount} onChange={e => setMAmount(e.target.value)} style={inputStyle} required min={1} />
            </div>
            <div>
              <label style={labelStyle}>Арга</label>
              <select value={mMethod} onChange={e => setMMethod(e.target.value)} style={inputStyle}>
                <option value="cash">Бэлэн мөнгө</option>
                <option value="bank_transfer">Банк шилжүүлэг</option>
              </select>
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Лавлах дугаар / тэмдэглэл</label>
              <input value={mReference} onChange={e => setMReference(e.target.value)} style={inputStyle} placeholder="Банкны гүйлгээний дугаар г.м." />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <button type="submit" disabled={mSaving} style={{ ...btnPrimary, opacity: mSaving ? 0.6 : 1 }}>
                {mSaving ? 'Бүртгэж байна...' : 'Бүртгэх'}
              </button>
            </div>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Огноо</th>
                <th style={th}>Орон сууц</th>
                <th style={th}>Хугацаа</th>
                <th style={th}>Дүн</th>
                <th style={th}>Арга</th>
                <th style={th}>Статус</th>
                <th style={th}>Лавлах</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p: any) => (
                <tr key={p.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                  <td style={td}>{p.created_at ? new Date(p.created_at).toLocaleDateString() : '-'}</td>
                  <td style={td}><strong>{p.unit_label || '-'}</strong></td>
                  <td style={td}>{p.period || '-'}</td>
                  <td style={td}>₮{(p.amount ?? 0).toLocaleString()}</td>
                  <td style={td}>{METHOD_LABELS[p.method] || p.method}</td>
                  <td style={td}>
                    <span style={{
                      background: (STATUS_COLORS[p.status] || '#6b7280') + '20',
                      color: STATUS_COLORS[p.status] || '#6b7280',
                      padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
                    }}>{STATUS_LABELS[p.status] || p.status}</span>
                  </td>
                  <td style={{ ...td, fontSize: 12, color: '#5f6f66' }}>{p.transaction_id || p.notes || '-'}</td>
                </tr>
              ))}
              {payments.length === 0 && (
                <tr><td colSpan={7} style={{ ...td, textAlign: 'center', color: '#94a3b8' }}>Төлбөр бүртгэгдээгүй</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
